import {  createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var DeleteTestRes;
export const DeleteTestTodo = createAsyncThunk('DeleteTest', async (id) => {
    // console.log("data", data)
    try {
        const res = await axios({
            method: "Delete",
            url: process.env.REACT_APP_API_URL + `admin/test/${id}`,
            params: {
                "company_id": localStorage.getItem('companyId')
            },
            headers: { "Content-Type": "application/json" , "Authorization": 'Bearer ' + localStorage.getItem('user_token') }
        })
        return DeleteTestRes = res.data
        
    } catch (error) {
        return DeleteTestRes = error.response.data
    }
})
